const state = {
  user: {
    address: '',
    addressDetail: '',
    del: false,
    email: '',
    enabled: false,
    enterpriseName: '',
    id: 0,
    isRequiredUpdatePassword: false,
    mobileNumber: '',
    nickname: '',
    notificationChat: false,
    notificationKeyword: false,
    notificationQna: false,
    notificationFree: false,
    notificationFreeReply: false,
    notificationKnowhow: false,
    notificationKnowhowReply: false,
    providerId: '',
    telNumber: '',
    temporaryEmail: false,
    userId: '',
    username: '',
    zipcode: '',
    photo: '',
    photoThumb: '',
  },
  owner: {
    storename: '',
    telNumber: '',
    zipcode: '',
    address: '',
    addressDetail: '',
    counselEnd: '',
    counselStart: '',
    removeStorePhoto: [],
    storePhoto: [],
    info: '',
  },
  users: {
    isLoading: false,
    data: [],
    pagination: {
      totalElements: 0,
      startReverseIndex: 0,
    },
  },
  owners: {
    isLoading: false,
    data: [],
    pagination: {
      totalElements: 0,
      startReverseIndex: 0,
    },
  },
  authArea: [],
  userStatus: [],
};

export default state;
